import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

export default function Amenagement({navigateWithTransition}) {




return (

<div className="Amenagement">




</div>

)

}